// Mirrors the route guard on the CSAT dashboard, create/edit and reports
// routes (routes/index.jsx): only these groups may open them.
export const CSAT_MANAGER_GROUPS = ['CSAT / Manager', 'Administration / Settings'];

export const isCsatManager = (userdetails) =>
  !!userdetails?.is_superuser
  || CSAT_MANAGER_GROUPS.some((group) => userdetails?.group_names?.includes(group));
